function isObject(value) {
    return (!Array.isArray(value)
        && value instanceof Object
        && typeof value === 'object');
}
export default isObject;
//# sourceMappingURL=is-object.js.map